// Cyreen and tenant may edit a record even when it belongs to another company.
// Retailer, branch, and brand users still have to match the record's owner.
export const CROSS_COMPANY_EDIT_USER_TYPES = ["cyreen", "tenant"];

export const canEditAcrossCompanies = (userType) => {
    const normalizedUserType = typeof userType === "string" ? userType.toLowerCase() : "";
    return CROSS_COMPANY_EDIT_USER_TYPES.includes(normalizedUserType);
};

// Campaign list Share: Cyreen ignores owner; tenant and others must own the campaign.
export const canShareCampaignByOwner = (userType, userInfo, campaign) => {
    const normalizedUserType = typeof userType === "string" ? userType.toLowerCase() : "";
    if (normalizedUserType === "cyreen") {
        return true;
    }
    const userCompanyId =
        userInfo?.assigned_company?.id ?? userInfo?.current_workspace?.id;
    if (userCompanyId === undefined || userCompanyId === null || userCompanyId === "") {
        return false;
    }
    return String(userCompanyId) === String(campaign?.owner_company_id);
};

// Create forms show an Owner field for these users. An empty choice is an error.
export const ownerRequiredOnCreate = (userType, validateFor, ownerId) => {
    const ownerIsMissing = ownerId === "" || ownerId === null || typeof ownerId === "undefined";
    return ownerIsMissing === true && validateFor !== "update" && canEditAcrossCompanies(userType) === true;
};

// On create, send the owner they picked. On update the record already has an owner.
export const shouldSendSelectedOwner = (userType, validateFor, ownerId) => {
    const ownerWasChosen = ownerId !== "" && ownerId !== null && typeof ownerId !== "undefined";
    return ownerWasChosen === true && validateFor !== "update" && canEditAcrossCompanies(userType) === true;
};

// Everyone else is saved under their own assigned company.
export const ownerCompanyIdForSave = (userDetail, selectedOwnerId) => {
    if (canEditAcrossCompanies(userDetail?.user_type) === true) {
        return selectedOwnerId;
    }
    return userDetail?.assigned_company?.id;
};
